import { call, put } from 'redux-saga/effects';
import {
  createDepositFail,
  createDepositSuccess,
  getAllDepositsFail,
  getAllDepositsSuccess,
  getDepositDetailFail,
  getDepositDetailSuccess,
  importDepositsFromExcelFail,
  importDepositsFromExcelSuccess,
  getAllDepositsSPEISuccess,
  getAllDepositsSPEIFail,
  getDepositSPEIDetailSuccess,
  getDepositSPEIDetailFail,
  getDepositDetailFiservSuccess,
  getDepositDetailFiservFail,
  getAllDepositsFiservSuccess,
  getAllDepositsFiservFail,
  getAllDepositsFiservToDownloadSuccess,
  countAllDepositsSuccess,
} from 'app/features/deposits/depositsSlice';

import { formatDatesForFilter,formatDatesForFilterBp } from 'app/utils';
import { getLogs } from 'app/features/logs/logsSlice';
import { requestHandler } from '../../services/requestHandler';
import moment from 'moment';

export function* getAllDepositsSaga(action) {
  try {
    const { page, pageSize, filtered } = action.payload;
    let firstDate = action.payload.firstDate
      ? action.payload.firstDate
      : '';
    let secondDate = action.payload.secondDate
      ? action.payload.secondDate
      : '';
    const data = {
      where: {},
      agencies: {
        options: {
          attributes: ['id', 'isActiveAgency', 'name'],
        },
      },
      pagination: {
        page,
        perPage: pageSize,
      },
      options: {
        order: [['updatedAt', 'DESC']],
        count: true,
        distinct: true,
      },
      depositPayments: {
        payments: {
          serviceOrders: {
            agencies: {
              options: {
                attributes: ['name'],
              },
            },
            invoiceProfiles: true,
          },
          paymentOrders: {
            agencies: {
              options: {
                attributes: ['name'],
              },
            },
          },
        },
      },
    };
    if (filtered.length) {
      filtered.forEach((filter) => {
        if (filter.id === 'id') data.where['id'] = filter.value;
        else if (filter.id === 'agency.name')
          data.agencies = {
            where: {
              name: {
                $iLike: `%${filter.value}%`,
              },
            },
          };
        else if (filter.id === 'name')
          data.where['name'] = {
            $iLike: `%${filter.value}%`,
          };
        else if (filter.id === 'amount')
          data.where['amount'] = filter.value;
        else if (filter.id === 'depositTime')
          data.where['depositTime'] = formatDatesForFilterBp(
            filter.value,
          );
        else data.where[filter.id] = filter.value;
      });
    }
    if (firstDate !== '' && secondDate !== '') {
      // prettier-ignore
      data.where.depositTime = formatDatesForFilterBp(firstDate, secondDate);
    }
    const deposits = yield call(requestHandler, {
      method: 'POST',
      path: '/deposits/getAll',
      data,
    });
    deposits.pages = yield call(Math.ceil, deposits.count / pageSize);
    yield put(getAllDepositsSuccess({ deposits }));
  } catch (e) {
    yield put(getAllDepositsFail('getPaymentSaga'));
    console.log('error in get payment saga', e);
  }
}

export function* getAllSpeiPaymentsValidatedSaga(action) {
  try {
    const { page, pageSize, filtered } = action.payload;
    const data = {
      where: {},
      agencies: {
        options: {
          attributes: ['id', 'isActiveAgency', 'name'],
        },
      },
      pagination: {
        page,
        perPage: pageSize,
      },
      options: {
        order: [['updatedAt', 'DESC']],
      },
    };
    if (filtered.length) {
      filtered.forEach((filter) => {
        if (filter.id === 'id') data.where['id'] = filter.value;
        else if (filter.id === 'agency.name')
          data.agencies = {
            where: {
              name: {
                $iLike: `%${filter.value}%`,
              },
            },
          };
        else if (filter.id === 'name')
          data.where['name'] = {
            $iLike: `%${filter.value}%`,
          };
        else if (filter.id === 'amount')
          data.where['amount'] = filter.value;
        else if (filter.id === 'createdAt')
          data.where['createdAt'] = formatDatesForFilter(
            filter.value,
          );
        else data.where[filter.id] = { $iLike: `%${filter.value}%` };
      });
    }

    const deposits = yield call(requestHandler, {
      method: 'POST',
      path: '/deposits/getAll',
      data,
    });
    yield put(getAllDepositsSuccess({ deposits }));
  } catch (e) {
    yield put(getAllDepositsFail('getPaymentSaga'));
    console.log('error in get payment saga', e);
  }
}

// export function* getPaymentsForDownloadSaga(action) {
//   try {
//     let payments;
//     let { data } = action;
//     delete data.options;
//     delete data.pagination;

//     if (data)
//       payments = yield call(requestHandler, {
//         method: 'POST',
//         path: '/payment/getAll',
//         data,
//       });
//     yield put(getPaymentsForDownloadSuccess({ payments }));
//   } catch (e) {
//     yield put(getPaymentsForDownloadFail('getPaymentSaga'));
//     console.log('error in get payment saga', e);
//   }
// }

export function* getDepositDetailSaga(action) {
  try {
    const { id } = action.payload;
    const data = {
      where: { id },
      agencies: true,
      SPEIPayments: {
        payments: true,
      },
      depositPayments: {
        payments: {
          serviceOrders: {
            agencies: {
              options: {
                attributes: ['name'],
              },
            },
            invoiceProfiles: true,
          },
          paymentOrders: {
            agencies: {
              options: {
                attributes: ['name'],
              },
            },
          },
        },
      },
    };
    const deposit = yield call(requestHandler, {
      method: 'POST',
      path: '/deposits/getOne',
      data,
    });
    yield put(
      getLogs({
        object: 'deposits',
        objectID: id,
      }),
    );
    yield put(getDepositDetailSuccess({ deposit }));
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaba obtener información pago.
      Intente de nuevo, si el error persiste intente más tarde.`,
    };
    yield put(getDepositDetailFail({ message }));
    console.log('error in get detail payment saga', e);
  }
}

export function* createDepositSaga(action) {
  try {
    const { changeToDepositsCreated, ...rest } = action.payload;
    const data = rest;
    yield call(requestHandler, {
      method: 'POST',
      path: '/deposits/create',
      data,
    });
    const message = {
      title: 'Depósito creado',
      desc: `El depósito hasido creado correctamente`,
    };

    yield put(createDepositSuccess({ message }));
    yield call(changeToDepositsCreated);
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaba crear el depósito.
      Intente de nuevo, si el error persiste intente más tarde.`,
    };
    yield put(createDepositFail({ message }));
    console.log('error in get detail payment saga', e);
  }
}

export function* importDepositsFromExcelSaga(action) {
  try {
    const { data, handleRefreshData } = action.payload;
    yield call(requestHandler, {
      method: 'POST',
      path: '/deposits/importFromExcel',
      data,
    });
    const message = {
      title: 'Depósitos importados',
      desc: '¡Los depósitos han sido importados correctamente!',
    };

    yield put(importDepositsFromExcelSuccess({ message }));
    yield call(handleRefreshData);
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaban importar los depósitos.
      Intente de nuevo, si el error persiste intente más tarde.`,
    };
    yield put(importDepositsFromExcelFail({ message }));
    console.log('error in get detail payment saga', e);
  }
}

export function* depositsSPEISaga(action) {
  try {
    const { page, pageSize, filtered } = action.payload;
    let offset = 0;
    let search = [];
    let filter = [];
    let firstDate = action.payload.firstDate
      ? action.payload.firstDate
      : '';
    let secondDate = action.payload.secondDate
      ? action.payload.secondDate
      : '';
    if (filtered.length) {
      filtered.forEach((filters) => {
        if (filters.id === 'agencyName') {
          search.push('agencyName');
          filter.push(filters.value);
        }
        if (filters.id === 'depositTime') {
          search.push('depositTime');
          filter.push(filters.value);
        }
        if (filters.id === 'totalAmount') {
          search.push('totalAmount');
          filter.push(filters.value);
        }
      });
    }
    if (page > 0) {
      offset = pageSize * page;
    }
    const data = {
      where: {},
      agencies: {
        options: {
          attributes: ['id', 'isActiveAgency', 'name'],
        },
      },
      search,
      filter,
      offset,
      limit: pageSize,
      field: 'createdAt',
      ordering: 'DESC',
    };
    if (firstDate !== '' && secondDate !== '') {
      // prettier-ignore
      data.where.depositTime = formatDatesForFilter(firstDate, secondDate);
    }
    const deposits = yield call(requestHandler, {
      method: 'POST',
      path: '/depositSpeis/getAll',
      data,
    });
    deposits.pages = yield call(Math.ceil, deposits.count / pageSize);
    yield put(getAllDepositsSPEISuccess({ deposits }));
  } catch (e) {
    yield put(getAllDepositsSPEIFail());
    console.log('error in get SPEI deposits saga', e);
  }
}

export function* getDepositSPEIDetailSaga(action) {
  try {
    const { id } = action.payload;
    const data = {
      id,
    };
    const deposit = yield call(requestHandler, {
      method: 'POST',
      path: '/depositSpeis/getOne',
      data,
    });
    yield put(getDepositSPEIDetailSuccess({ deposit }));
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaba obtener información pago.
      Intente de nuevo, si el error persiste intente más tarde.`,
    };
    yield put(getDepositSPEIDetailFail({ message }));
    console.log('error in get SPEI deposit details saga', e);
  }
}

export function* getAllDepositsFiservSaga(action) {
  const { page, pageSize, sorted, filtered } = action.payload;
  try {
    let offset = 0;
    let firstDate = action.payload.firstDate
      ? moment(action.payload.firstDate).format('YYYY-MM-DDT00:00:00')
      : '';
    let secondDate = action.payload.secondDate
      ? moment(action.payload.secondDate).format(
          'YYYY-MM-DDT23:59:59',
        )
      : '';

    let where = {};
    if (filtered.length) {
      filtered.forEach((filters) => {
        where = {
          ...where,
          [filters.id]: filters.value,
        };
      });
    }

    let ordering = 'DESC';
    if (sorted.length > 0 && sorted[0].id === 'depositDate') {
      ordering = sorted[0].desc ? 'DESC' : 'ASC';
    }

    if (page > 0) {
      offset = pageSize * page;
    }

    const data = {
      where,
      offset,
      limit: pageSize,
      field: 'depositDate',
      ordering,
      firstDate: firstDate,
      secondDate: secondDate,
      agencies: {
        options: {
          attributes: ['id', 'isActiveAgency', 'name'],
        },
      },
    };

    const deposits = yield call(requestHandler, {
      method: 'POST',
      path: '/depositsFiservs/getAll',
      data,
    });
    if (firstDate && secondDate) {
      data.limit = 100;
      const depositsReport = yield call(requestHandler, {
        method: 'POST',
        path: '/depositsFiservs/getAll',
        data,
      });
      yield put(
        getAllDepositsFiservToDownloadSuccess({
          deposits: depositsReport,
        }),
      );
    }
    deposits.pages = yield call(Math.ceil, deposits.count / pageSize);
    yield put(getAllDepositsFiservSuccess({ deposits }));
  } catch (e) {
    yield put(getAllDepositsFiservFail('getPaymentSaga'));
    console.log('error in get payment saga', e);
  }
}

export function* getDepositFiservDetailSaga(action) {
  try {
    const { id } = action.payload;
    let data = {
      where: { id },
      agencies: true,
      depositFiservDetails: {
        payments: {
          serviceOrders: {
            agencies: {
              options: {
                attributes: ['name'],
              },
            },
            invoiceProfiles: true,
          },
          paymentOrders: {
            agencies: {
              options: {
                attributes: ['name'],
              },
            },
          },
        },
      },
    };
    /* data = { id: id }; */
    const deposit = yield call(requestHandler, {
      method: 'POST',
      path: '/depositsFiservs/getOne',
      data,
    });
    yield put(
      getLogs({
        object: 'deposits',
        objectID: id,
      }),
    );
    yield put(getDepositDetailFiservSuccess({ deposit }));
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaba obtener información pago.
      Intente de nuevo, si el error persiste intente más tarde.`,
    };
    yield put(getDepositDetailFiservFail({ message }));
    console.log('error in get detail payment saga', e);
  }
}

//TODO: Terminar metodos y probar si ya guarda el resultado en el state
export function* countDepositFiservDetailSaga(action) {
  try {
    const deposit = yield call(requestHandler, {
      method: 'POST',
      path: '/deposits/getCountAll',
    });
    yield put(countAllDepositsSuccess({ deposit }));
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaba contar los depositos.
      Intente de nuevo, si el error persiste intente más tarde.`,
    };
    yield put(getDepositDetailFiservFail({ message }));
    console.log('error in get detail payment saga', e);
  }
}
